import { SESSIONSTORAGE_KEYS } from '@constants/index';
export var initialUserInfo = (() => {
  var localUserInfo = sessionStorage.getItem(SESSIONSTORAGE_KEYS.USERINFO);

  var _userInfo = localUserInfo ? JSON.parse(localUserInfo) : {};

  return _userInfo;
})();
export var userInfo = initialUserInfo;
/**
 * syncUserInfo for http
 *
 * @export
 * @param {IAuthStore.UserInfo} data
 */

export function syncUserInfo(data) {
  userInfo = data;
}